import Model     from "./../core/Model";
import Validator from "./../core/Validator";
import City      from "./City";
import Comment   from "./Comment";
import User      from "./User";
import Rq        from "./Rq";

export default class Review extends Model
{
    constructor( options = {} )
    {
        super('/api/reviews');

        this.setOptions(options);

        this.validator = new Validator({

            target        : { required: true,  type : 'object' },
            target_type   : { required: true,  type : 'string' },
            worked_at     : { required: false, type : 'string' },
            rate          : { required: true,  type : 'integer',      options : { min : 1, max : 5   } },
            'comment.content' : { required: true, type : 'string'},
            'user.name'   : { required: true,  type : 'string',       options : { min : 1, max : 128 } },
            'user.email'  : { required: true,  type : 'email'  },
        }, {

            target        : 'target is required',
            target_type   : 'target type is required',
            rate          : 'You must provide a valid rate',
            'comment.content' : 'ASDA AS DASD ASD SA DAS D',
            'user.name'   : 'You must provide your name',
            'user.email'  : 'You must provide an email',
        });
    }

    setOptions( options = {} )
    {
        this.id                  = options.id               || null;
        this.target              = options.target           || null;
        this.target_type         = options.target_type      || null;
        this.rate                = options.rate             || 0;
        this.anonymous           = options.anonymous        || false;
        this.spam                = options.spam             || 0;
        this.score               = options.score            || null;
        this.type                = options.type             || null;
        this.worked_at           = options.worked_at        || null;
        this.site                = options.site             || null;
        this.rq                  = typeof options.rq       === 'Rq'       ? options.rq       : new Rq(       options.rq         || {} );
        this.user                = typeof options.user     === 'User'     ? options.user     : new User(     options.user       || {} );
        this.comment             = typeof options.comment  === 'Comment'  ? options.comment  : new Comment(  options.comment    || {} );
        this.city                = typeof options.city     === 'City'     ? options.city     : new City(     options.city       || {} );
        this.related             = options.related          || null;
        this.related_type        = options.related_type     || null;
    }

    toJson ()
    {
        return {

            id              : this.id,
            rate            : this.rate,
            ip              : this.ip,
            anonymous       : this.anonymous,
            spam            : this.spam,
            user            : this.user.toJson(),
            comment         : this.comment.toJson(),
            target_type     : this.target_type,
            target          : this.target ? this.target.toJson() : null,
            rq              : this.rq     ? this.rq.toJson()     : null,
            city            : this.city         ? this.city.toJson()   : null,
            worked_at       : this.worked_at,
            site            : this.site,
            related_type    : this.related_type,
            related         : this.related ? this.related.toJson() : null,
        }
    }

    save() {

        let self   = this,
            url    = this._base_url,
            method = 'POST';

        return new Promise((resolve, reject) => {

            return axios({

                method: method,
                url:    url,
                data:   self.toJson()
            })
                .then(function (response) {

                    self.setOptions( response.data );

                    resolve(response);

                }).catch(function (error) {

                    console.log(error);
                    reject(error)
                });
        });
    }
}



// WEBPACK FOOTER //
// ./resources/js/models/Review.js